import { Flex, Typography } from "antd"
import React from "react"
import { Link } from "react-router-dom"

import { RoutesPaths } from "../../../../../constants/routes.ts"
import Icon from "../../../../../Icon"
import { SettingsCard } from "../../common/SettingsCard.tsx"

const { Text } = Typography

// Company HQ only. Links to Settings → Company Defaults (Configurations),
// which owns default_timezone/default_working_days/default_business_hours —
// a different, smaller set of defaults than this page's own Operational
// defaults card (lead cost method, default tax %, invoice/alert
// thresholds), which stays on this page because Company Defaults has no
// write path for those fields.
export function CompanyDefaultsShortcutCard() {
  return (
    <SettingsCard
      iconWrapperClassName="bg-amber-100"
      icon={<Icon type={"Settings"} className="text-amber-600" />}
      title="Company defaults"
    >
      <Flex justify="space-between" align="center" gap={"middle"} wrap>
        <Text type="secondary">
          Manage shared defaults. Branch overrides stay independent.
        </Text>
        <Link to={RoutesPaths.settings.configuration} className="whitespace-nowrap">
          Manage defaults →
        </Link>
      </Flex>
    </SettingsCard>
  )
}
